import { useEffect } from 'react';
import { keyEventListeners } from '../components/shared/constants';

/**
 * useKeyPress
 * @param {array} keyNames - Array of keyHandlers to be executed on keyDown
 * @returns {undefined} no return value
 */

export const useKeyDown = (keyHandlers) => {
  
  useEffect(() => {
    keyHandlers.forEach((keyHandler) =>
      window.addEventListener(keyEventListeners.keyDown, keyHandler)
    );

    return () =>
      keyHandlers.forEach((keyHandler) =>
        window.removeEventListener(keyEventListeners.keyDown, keyHandler)
      );
  }, []);
};
